import styled from 'styled-components';

import { Colors } from '@formstack/phoenix/components/colors/constants';

import { BaseLayoutElement } from '@/common/components/Layout/LayoutComponents';

export const Base = styled(BaseLayoutElement).attrs((p) => ({ ...p, className: 'Base' }))`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  position: relative;
`;
export const InnerBasePrimary = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'InnerBasePrimary',
}))`
  flex: 1 0 auto;
  display: block;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  margin: 1.9375em 11.25em;
`;
export const InnerBaseSecondary = styled(InnerBasePrimary).attrs((p) => ({
  ...p,
  className: 'InnerBaseSecondary',
}))<any>`
  margin: 0;
`;
export const Section = styled(BaseLayoutElement).attrs((p) => ({ ...p, className: 'Section' }))`
  margin-bottom: 2em;

  &:last-child {
    margin-bottom: 0;
  }
`;
export const Header = styled(Section).attrs((p) => ({ ...p, className: 'Header' }))<any>`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  flex-wrap: wrap;
  row-gap: 0.5em;
`;
export const ViewHeader = styled(Header)`
  border-bottom: 1px solid ${Colors['phx-gray-3']};
  padding-bottom: 12px;
`;
export const Title = styled(BaseLayoutElement).attrs((p) => ({ ...p, className: 'Title' }))`
  flex: 0 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
`;
export const HeaderSpacer = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'HeaderSpacer',
}))`
  flex: 1 0 auto;
  width: auto;
  height: auto;
`;
export const ContentFlex = styled(Section).attrs((p) => ({ ...p, className: 'ContentFlex' }))<any>`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
`;
export const ContentStack = styled(ContentFlex).attrs((p) => ({ ...p, className: 'ContentStack' }))`
  align-items: flex-start;
`;
export const ContentHeader = styled(Header).attrs((p) => ({ ...p, className: 'ContentHeader' }))`
  margin-bottom: 0;
`;
export const ContentTitle = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'ContentTitle',
}))`
  font-size: 1em;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3125em;
  letter-spacing: 0;
  text-align: left;
  color: ${Colors['phx-gray-7']};
  margin-bottom: 0.3125em;
`;
export const ContentDescription = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'ContentDescription',
}))`
  font-size: 0.875em;
  font-style: normal;
  font-weight: 500;
  line-height: 1.125em;
  letter-spacing: 0;
  text-align: left;
  color: ${Colors['phx-default-text']};
  margin-bottom: 1.625em;
  margin-top: 0.875em;
  max-width: 600px;
`;
export const ContentHR = styled(Section).attrs((p) => ({ ...p, className: 'ContentHR' }))`
  flex: 1 0 auto;
  width: auto;
  height: 0.05em;
  background-color: ${Colors['phx-gray-3']};
`;
export const ContentSpacer = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'ContentSpacer',
}))`
  flex: 1 0 auto;
  width: auto;
  height: auto;
`;
export const ViewContainer = styled(InnerBaseSecondary)`
  margin: 31px;
`;
export const DetailsPanel = styled(Section)`
  border: 1px solid ${Colors['phx-gray-3']};
  border-radius: 4px;
  padding: 31px;
`;
export const Footer = styled(Section).attrs((p) => ({ ...p, className: 'Footer' }))<any>`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
export const ControlGroupBox = styled(BaseLayoutElement).attrs((p) => ({
  ...p,
  className: 'ControlGroupBox',
}))<any>`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
export const StandardIcon = styled.img`
  width: 31px;
  height: 31px;
  margin-right: 12px;
`;
